module.exports = __webpack_public_path__ + "img/3.b4a4b383.jpg";